export default {
  methods: {
    /**
     * checks against a regex i found
     * https://emailregex.com/
     *
     * @param {String} email - email to check
     * @return {Boolean} - whether or not it's good
     */
    emailIsValid(email) {
      // eslint-disable-next-line no-useless-escape
      const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return emailRegex.test(email)
    },

    /**
     * extracts initials appropriately from either email or name
     *
     * @param {String} emailOrName - email (or full name) to extract initials from
     * @return {String} - initial to return
     */
    extractInitials(emailOrName) {
      const separatedString = emailOrName.trim().split(' ')
      if (separatedString.length === 1)
        return separatedString[0][0].toUpperCase()
      else
        return `${separatedString[0][0].toUpperCase()}${separatedString[
          separatedString.length - 1
        ][0].toUpperCase()}`
    },
    /**
     * formats currency string, float, etc from something like "24.5" to
     * "$24.50"
     *
     * @param {number} currencyAmount - currency amount
     * @return {String} - formatted currency string
     */
    formatCurrency(currencyAmount) {
      if (currencyAmount == 'TBD') return 'TBD'
      return `$${parseFloat(currencyAmount)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`
    },

    formatDate(date) {
      let newDate = new Date(date)

      return newDate.toLocaleDateString('en-US')
    },
    /**
     * check if the url for the team logo exist
     *
     * @param {String} url - team logo
     * @return {String} - logo url
     */
    getLogoUrl(url) {
      if (url) {
        return url
      } else {
        return require('../assets/gemnote_logo_pebble.png')
      }
    },

    /**
     * Converts a date to UTC midnight (00:00:00.000)
     * @param {Date} date - The date to convert
     * @returns {Date} A new Date object set to UTC midnight
     */
    formatToUTCMidnight(date) {
      return new Date(
        Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          0,
          0,
          0,
          0
        )
      )
    },
    /**
     * Converts a date to UTC midnight (00:00:00.000)
     * @param {Date} date - The date to convert
     * @returns {String} A formatted date range string
     */
    formatDateFilterRange(startDate, endDate) {
      if (!startDate || !endDate) return ''

      const formatDate = date => {
        const months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ]
        const month = months[date.getMonth()]
        const day = date
          .getDate()
          .toString()
          .padStart(2, '0')
        const year = date.getFullYear()
        return `${month} ${day}, ${year}`
      }

      // If start and end dates are the same (Today or Yesterday case)
      if (startDate.getTime() === endDate.getTime()) {
        return formatDate(startDate)
      }

      return `${formatDate(startDate)} - ${formatDate(endDate)}`
    }
  }
}
